import React from 'react';
import './Services.css';
import { servicesList, CONFIG } from '../data';
function Services() {
  return (
    <section id="services" className="services section">
      <div className="container">
        <span className="section-label">What We Offer</span>
        <h2 className="section-heading">Catering for Every <em>Occasion</em></h2>
        <p className="section-desc">From intimate gatherings to grand wedding feasts — we handle everything with authentic Chettinad flavors.</p>
        <div className="svc-grid">
          {servicesList.map((s,i) => (
            <div key={i} className="svc-card">
              <span className="svc-icon">{s.icon}</span>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              <a href={`https://wa.me/${CONFIG.whatsappNumber}?text=${encodeURIComponent('Hi, I need catering for '+s.title)}`} target="_blank" rel="noopener noreferrer" className="svc-link">Enquire Now →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
export default Services;
